
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.822 2a1 1 0 10-2 0v1.488a1 1 0 102 0V2zM5.271 3.363a1 1 0 10-1.542 1.274l1 1.21a1 1 0 101.542-1.273l-1-1.21zm10.983 1.294a1 1 0 10-1.508-1.314l-1.055 1.21a1 1 0 001.507 1.315l1.056-1.21zm-6.19.436c-3.14 0-5.484 2.893-4.832 5.966l.055.26A7.232 7.232 0 007 14.67V16a3 3 0 106 0v-1.283a6.758 6.758 0 001.969-4.093l.007-.07a4.94 4.94 0 00-4.912-5.461zM9 16v-.72h2V16a1 1 0 11-2 0zM2 9.186a1 1 0 100 2h1.5a1 1 0 100-2H2zm14.5 0a1 1 0 100 2H18a1 1 0 100-2h-1.5zm-4.084.091a.5.5 0 10-.832-.554l-.328.492a4.5 4.5 0 00-.756 2.496V12a.5.5 0 001 0v-.289a3.5 3.5 0 01.588-1.941l.328-.493zm-4.693-.693a.5.5 0 00-.139.693l.328.493A3.5 3.5 0 018.5 11.71V12a.5.5 0 001 0v-.289a4.5 4.5 0 00-.756-2.496l-.328-.492a.5.5 0 00-.693-.139z","fill":"currentColor"}})])
          )
        }
      }
    